import React from "react";
import { Helmet } from "react-helmet-async";

import "./Members.scss";
import members from "./MembersList/MembersList";
import team from "./../../img/members/team.jpg";
import placeholder from "./../../img/members/placeholder.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons";

export default function Members() {
  console.log(members);
  return (
    <>
      <Helmet>
        <title>Members | M-Fly</title>
      </Helmet>
      <div className="Members">
        <div className="text-center leadership-header">
          <h1>Leadership</h1>
            <img
              src={team}
              alt="Team"
              className="leadership-img"
            />
        </div>
        {members.map((group) => (
          <div className="team-group" key={group.name}>
            <div className="text-center">
              <h1>{group.name}</h1>
            </div>
            <ul className="card-container">
              {group.list.map((member) => (
                <li className="card-item" key={member.name}>
                  <div className="card">
                    {member.linkedin ? (
                      <a
                        href={member.linkedin}
                        target="_blank"
                        rel="noreferrer noopener"
                      >
                        <img
                          src={member.image ?? placeholder}
                          alt={member.name}
                          className="card-image"
                          style={member.name === "Benjamin Gardiner" 
                                ? { objectPosition: "center 40%" }
                                : member.name === "Ava Esselman"
                                ? { objectPosition: "center 50%"}
                                : member.name === "Amit Kamath"
                                ? { objectPosition: "center 100%"}
                                : undefined}
                        />
                      </a>
                    ) : (
                      <img
                        src={member.image ?? placeholder}
                        alt={member.name}
                        className="card-image"
                      />
                    )}
                    <h2 className="card-title">
                      {member.linkedin ? (
                        <>
                          <a
                            href={member.linkedin}
                            target="_blank"
                            rel="noreferrer noopener"
                          >
                            {member.name}
                            <FontAwesomeIcon 
                              icon={faLinkedin} 
                              style={{ 
                                marginLeft: '0.4em', 
                                color: 'lightsteelblue'
                              }} 
                            />
                          </a>
                        </>
                      ) : (
                        member.name
                      )}
                    </h2>
                    <p className="card-text">
                      <span className="card-subtitle">{member.position}</span>
                      {member.major && member.year && (
                        <span>
                          {member.major}, {member.year}
                        </span>
                      )}
                      {/* <span className="card-subtitle">{member.minor}</span> */}
                    </p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </>
  );
}
